export const siteSettings = {
  name: "Trust Finance",
  link: "https://trustfinanceltd.com",
  email: "support@trustfinanceltd.com",
  appLink: "https://app.trustfinanceltd.com",
};
